var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 16 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 4.541v7.834c0 .894-.72 1.625-1.6 1.625H1.6C.72 14 0 13.269 0 12.375l.005-7.32 7.592 4.82L16 4.541zM14.4 0c.88 0 1.6.731 1.6 1.625v1.496L7.597 8.455.006 3.636l.002-2.011C.008.781.643.082 1.455.007L1.6 0z"
})));
export default SvgIconEmail;